import { Iterable } from 'immutable'

const wrappedPropsToJs = wrappedProps => {
    const KEY = 0
    const VALUE = 1

    const propsJS = Object.entries(
        wrappedProps
    ).reduce((newProps, wrappedProps) => {
        newProps[wrappedProps[KEY]] = Iterable.isIterable(
            wrappedProps[VALUE]
        )
            ? wrappedProps[VALUE].toJS()
            : wrappedProps[VALUE]

        return newProps
    }, {})

    return propsJS
}

export default wrappedPropsToJs